import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIndustry, faMicroscope, faShoePrints } from '@fortawesome/free-solid-svg-icons';
import './HowWeWork.css';

const HowWeWork = () => {
    const { t } = useTranslation();

    const steps = [
        {
            number: '01',
            key: 'step1',
            icon: faMicroscope,
            color: 'primary'
        },
        {
            number: '02',
            key: 'step2',
            icon: faIndustry,
            color: 'secondary'
        },
        {
            number: '03',
            key: 'step3',
            icon: faShoePrints,
            color: 'accent'
        }
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5 }
        }
    };

    return (
        <section id="process" className="section process-section">
            <div className="container">
                {/* Header */}
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                >
                    <h2 className="section-title">{t('process.title')}</h2>
                    <p className="section-subtitle">{t('process.subtitle')}</p>
                </motion.div>

                {/* Steps */}
                <motion.div
                    className="steps-container"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    {steps.map((step, index) => (
                        <motion.div
                            key={step.key}
                            className={`step-card step-${step.color}`}
                            variants={itemVariants}
                        >
                            <div className="step-header">
                                <span className="step-number">{step.number}</span>
                                <span className={`step-icon-wrapper step-icon-wrapper-${step.color}`} aria-hidden="true">
                                    <span className={`step-icon step-icon-${step.color}`}>
                                        <FontAwesomeIcon icon={step.icon} />
                                    </span>
                                </span>
                            </div>
                            <div className="step-content">
                                <h3 className="step-title">{t(`process.${step.key}.title`)}</h3>
                                <p className="step-subtitle">{t(`process.${step.key}.subtitle`)}</p>
                                <p className="step-description">{t(`process.${step.key}.description`)}</p>
                            </div>
                            {index < steps.length - 1 && (
                                <div className="step-connector">
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <path d="M5 12h14m-7-7l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            )}
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default HowWeWork;
